import { thMeterSensorRegistry } from "./thMeterSensorRegistry";

export const generateThMetersDemo = () => {
    return thMeterSensorRegistry.map((meter) => ({
        meter_id: meter.meter_id,
        meter_name: meter.meter_name,
    }));
};
